import { createRouter, createWebHistory } from 'vue-router'
import TaskList from '../views/TaskList.vue'
import DailyPlan from '../views/DailyPlan.vue'
import Login from '../views/Login.vue'
import AiChat from '../views/AiChat.vue'
import Notepad from '../views/Notepad.vue'
import MoodWall from '../views/MoodWall.vue'
import * as userApi from '../api/user'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    redirect: '/daily'
  },
  {
    path: '/daily',
    name: 'DailyPlan',
    component: DailyPlan,
    meta: { requiresAuth: true }
  },
  {
    path: '/tasks',
    name: 'TaskList',
    component: TaskList,
    meta: { requiresAuth: true }
  },
  {
    path: '/ai',
    name: 'AiChat',
    component: AiChat,
    meta: { requiresAuth: true }
  },
  {
    path: '/notes',
    name: 'Notepad',
    component: Notepad,
    meta: { requiresAuth: true }
  },
  {
    path: '/mood',
    name: 'MoodWall',
    component: MoodWall,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫：检查登录状态
router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  
  if (requiresAuth) {
    try {
      // 检查是否已登录
      const res = await userApi.getCurrentUser()
      if (res.data.code === 200) {
        // 已登录，允许访问
        next()
      } else {
        // 未登录，跳转到登录页
        next('/login')
      }
    } catch (error) {
      // 请求失败，跳转到登录页
      next('/login')
    }
  } else {
    // 不需要认证的页面，直接访问
    next()
  }
})

export default router
